var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"Title","visible":_vm.visible},on:{"cancel":function($event){_vm.visible = _vm.fasle}}},[_c('crud',{ref:"crud",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }